import type { AudioTrack } from '../components/serene-audio-player';

/**
 * Default audio tracks - nature sounds from free sources
 * Based on research in SERENE_BREATHING_UX_RESEARCH.md Section 5
 *
 * Audio files should be placed in /public/audio/serene/
 * Recommended formats: OGG (primary) with MP3 fallback for Safari
 */
export const DEFAULT_AUDIO_TRACKS: AudioTrack[] = [
  {
    id: 'silence',
    name: 'Silence',
    url: '', // Empty URL means no audio playback
  },
  {
    id: 'rain',
    name: 'Gentle Rain',
    url: '/audio/serene/rain-loop.ogg',
    duration: 60,
  },
  {
    id: 'ocean',
    name: 'Ocean Waves',
    url: '/audio/serene/ocean-loop.ogg',
    duration: 60,
  },
  {
    id: 'forest',
    name: 'Forest Ambience',
    url: '/audio/serene/forest-loop.ogg',
    duration: 60,
  },
  {
    id: 'white-noise',
    name: 'Soft White Noise',
    url: '/audio/serene/white-noise-loop.ogg',
    duration: 60,
  },
];
